import { computed, defineComponent, watch } from 'vue';
import { validationRequired } from '@/core/helpers/validation';
export default defineComponent({
    props: {
        answerTypeId: String,
        scheme: {
            type: Object,
            default: () => {
                return {};
            }
        },
        statementFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        competencyUnit: {
            type: Object,
            default: () => {
                return {};
            }
        },
        disabled: Boolean,
        isAssessment: Boolean,
        order: Number
    },
    emits: ['update:statementFields', 'triggerCompleted'],
    setup(props, { emit }) {
        const modelStatementFields = computed({
            get() {
                return props.statementFields;
            },
            set(value) {
                emit('update:statementFields', value);
            }
        });
        const foundStatementIndex = (statementId, answerFieldId) => {
            const statementFields = modelStatementFields.value.findIndex((item) => {
                return item.statement.id === statementId;
            });
            const statementAnswerFields = modelStatementFields.value[statementFields].statementAnswerFields.findIndex((item) => {
                return item.formAnswerField.answerFieldId === answerFieldId;
            });
            return {
                statementFields,
                statementAnswerFields
            };
        };
        const checkCompleted = computed(() => {
            var _a;
            if (!props.isAssessment)
                return false;
            if (props.competencyUnit.statements.length &&
                props.competencyUnit.customAnswerFields.length) {
                return (_a = props.competencyUnit.statements) === null || _a === void 0 ? void 0 : _a.filter((item) => {
                    return item.answerTypeId === props.answerTypeId;
                }).map((statement) => {
                    var _a;
                    return (_a = props.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => {
                        return item.answerType.id === props.answerTypeId;
                    }).map((customAnswerField) => {
                        if (modelStatementFields.value[foundStatementIndex(statement.id, customAnswerField.answerField.id).statementFields].statementAnswerFields[foundStatementIndex(statement.id, customAnswerField.answerField.id).statementAnswerFields].value) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    });
                }).every((parent) => {
                    return parent.every((child) => {
                        return child;
                    });
                });
            }
            return false;
        });
        watch(() => {
            return checkCompleted.value;
        }, (newValue) => {
            emit('triggerCompleted', newValue);
        }, { immediate: true, deep: true });
        return {
            validationRequired,
            modelStatementFields,
            foundStatementIndex
        };
    }
});
